export const toDocumentOriginState = (origin) => ({ documentOrigin: origin });
/**
 * Router state survives in browser history, so it is read defensively and only
 * trusted when it points back inside the current study.
 */
export const readDocumentOrigin = (state, studyPath) => {
    if (typeof state !== 'object' || state === null || !('documentOrigin' in state)) {
        return undefined;
    }
    const { documentOrigin } = state;
    if (typeof documentOrigin !== 'object' || documentOrigin === null) {
        return undefined;
    }
    const { path, label } = documentOrigin;
    if (typeof path !== 'string' || typeof label !== 'string' || !label || !path.startsWith(`${studyPath}/`)) {
        return undefined;
    }
    return { path, label };
};
/** One-based `?page=` value to a zero-based page index; anything unusable opens page one. */
export const parsePageParam = (value) => {
    const page = Number(value);
    return Number.isInteger(page) && page > 1 ? page - 1 : 0;
};
